;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="97ddbce3-f826-4b71-8317-f56e6c0cabe5",e._sentryDebugIdIdentifier="sentry-dbid-97ddbce3-f826-4b71-8317-f56e6c0cabe5")}catch(e){}}();import { useSuggestSearchSupport } from './hopps.js';
import '../../../_virtual/_sentry-release-injection-file.js';

function useSearchEngine() {
    return useSuggestSearchSupport();
}

export { useSearchEngine };
//# sourceMappingURL=index.js.map
